export default "__VITE_ASSET__CAmWJ3At__"